$(function () {
    const searchPhoneBuyerModal = new bootstrap.Modal('#search_phone_name_selector');
    const searchPhoneBuyerModalBody = $('#search_phone_name_selector_body');
    const phone = $('#phone');
    let dataTable;
    let currentBuyerId = null;
    const option = {
        columns: [
            {
                title: '產品',
                data: 'name'
            },
            {
                title: '數量',
                data: 'quantity'
            },
            {
                title: '價格',
                data: 'amount'
            },
            {
                title: '到貨狀態',
                data: 'is_arrived',
                render: (data, type, row) => {
                    if (type === 'display') {
                        let html = '未到貨';

                        if (parseInt(data) === 1) {
                            html = '已到貨';
                        }

                        if (row.arrived_date !== null) {
                            html += `（${row.arrived_date}）`;
                        }

                        return html;
                    }

                    return data;
                }
            },
            {
                title: '訂單狀態',
                data: 'is_cancel',
                render: (data, type) => {
                    if (type === 'display') {
                        if (parseInt(data) === 1) {
                            return '已取消';
                        }

                        return '';
                    }

                    return data;
                }
            }
        ]
    };

    function requestData() {
        if (!currentBuyerId) {
            return;
        }

        let urlSuffix = 'products/unpaid';

        const url = `${apiPath}/${currentBuyerId}/${urlSuffix}`;

        chanMessage.loader.open();

        $.getJSON(url).done(response => {
            drawTable(response);
        }).fail(() => {
            chanMessage.alert('發生錯誤');
        }).always(() => {
            chanMessage.loader.close();
        });
    }

    function drawTable(data = []) {
        if (dataTable) {
            chanDrawTable.reset();
            $('#data_table thead').empty();
        }

        dataTable = chanDrawTable
            .setColumn(option)
            .setSearchModule([['#search_product_name', 0, 'input']])
            .draw('#data_table', data);
    }


    $('#btn_clear').on('click', () => {
        currentBuyerId = null;
        phone.val('');

        if (dataTable) {
            dataTable.clearSearch();
        }

        drawTable();
    });

    $('#btn_search_phone').on('click', function () {
        if (phone.val().trim() === '') {
            return;
        }

        chanMessage.loader.open();

        $.getJSON(apiBuyerSearchPhoneUrl, {
            phone: phone.val()
        }).done(function (response) {
            if (response.length === 0) {
                chanMessage.alert('沒有符合的號碼');
            } else if (response.length === 1) {
                currentBuyerId = response[0].id
                requestData();
            } else {
                searchPhoneBuyerModalBody.html($('#search_phone_buyer_selector_template').render(response));
                searchPhoneBuyerModal.show();
            }
        }).fail(function () {
            chanMessage.alert('發生錯誤');
        }).always(function () {
            chanMessage.loader.close();
        });
    });

    searchPhoneBuyerModalBody.on('click', 'a', function () {
        currentBuyerId = $(this).data('id');

        requestData();

        searchPhoneBuyerModal.hide();
        return false;
    });

    drawTable();
});
